import { useEffect } from 'react';

import { useAuth } from '@/contexts/AuthContext';
import { mergeSidewalkUpvotes } from '@/api/sidewalkUpvotes';

/** Renders nothing. After any sign-in, saves this device's yard-sign upvotes to the account. */
export default function SidewalkUpvoteMerger() {
  const { user } = useAuth();
  useEffect(() => {
    if (user?.id) mergeSidewalkUpvotes().catch(() => {});
  }, [user?.id]);
  return null;
}
